export class ResponseResult {
  code: string;
  timeStamp: string;
  success: boolean;
  message: string;
  data: any;
  constructor({
    code,
    timeStamp,
    success,
    message,
    data,
  }: { code: string; timeStamp: string; success: boolean; message: string; data: any }) {
    this.code = code;
    this.timeStamp = timeStamp;
    this.success = success;
    this.message = message;
    this.data = data;
  }
}
